import MicrochipIcon from './MicrochipIcon'

export default MicrochipIcon
